import { render, staticRenderFns } from "./BoardChairman.vue?vue&type=template&id=454a5c3c"
import script from "./BoardChairman.vue?vue&type=script&lang=js"
export * from "./BoardChairman.vue?vue&type=script&lang=js"
import style0 from "./BoardChairman.vue?vue&type=style&index=0&id=454a5c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports